import { ReactElement } from 'react'
import { CustomSpan } from './span.styles'
import { SpanStyleProps } from './span.styles'

interface SpanProps extends SpanStyleProps {
  text?: string | ReactElement
  onClick?: any
  textTransform?: React.CSSProperties['textTransform']
  style?: React.CSSProperties
}

export const Span = ({
  text,
  color,
  fontSize,
  fontWeight,
  textAlign,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  cursor,
  onClick,
  textTransform,
  style
}: SpanProps) => (
  <CustomSpan
    color={color}
    fontSize={fontSize}
    fontWeight={fontWeight}
    textAlign={textAlign}
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    marginRight={marginRight}
    cursor={cursor}
    onClick={onClick}
    textTransform={textTransform}
    style={style}
  >
    {text}
  </CustomSpan>
)
